import axios from "axios";
import { ethers } from 'ethers';

let signer;
let provider;
//let wbnbAddress = gon.wbnbAddress
let usdtAddress = gon.usdtAddress
//let wbnbDecimals = gon.wbnbDecimals
let usdtDecimals = gon.usdtDecimals
let isUser = gon.isUser
let ownerAddress = gon.ownerAddress;
let claimAddress = gon.claimAddress;


  async function loadWeb3() {
      if (window.ethereum && window.wallet == 'metamask' || typeof window.wallet == "undefined") {
        provider = new ethers.providers.Web3Provider(window.ethereum);
        signer = provider.getSigner();
        await ethereum.request({ method: 'eth_requestAccounts' })
        gon.provider = provider
        return signer.getAddress();
      }
  }

  window.connect = async function connect(is_admin=false) {
    if(typeof web3 === 'undefined' && mobileCheck()) {
      window.open(`https://metamask.app.link/dapp/` + location.hostname, '_blank').focus();
      return
    }else if (typeof web3 !== 'undefined') { 
      await load(is_admin);
      if (is_admin){
        debugger
        if (window.ethereum && window.ethereum.selectedAddress != ownerAddress) {
          alert('You dont have permission connect admin wallet');
          window.location.reload();
        }else{
          debugger
          var account = window.ethereum.selectedAddress;
          var maticBal = await window.maticBalance()
          await adminUserSession(account, maticBal)
          $('.adminConnectToWallet').hide()
          window.location.href = '/admin/dashboard'
        }
      }else{
        window.location.reload()
      }
    } else {
      toastr.error('Please install Metamask Extension to your browser. <a target="_blank" href="https://metamask.io/download.html">Download Here</a>')
    }
  }

  window.maticBalance = async function maticBalance() {
    var account = window.ethereum.selectedAddress
    var bal = await signer.getBalance();
    var maticBal = roundNumber(ethers.utils.formatEther(bal), 4);
    return maticBal;
  }

  window.mobileCheck = function() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };

  async function adminUserSession(address, eth, is_admin=true){
    const config = {
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    }
    const resp = await axios.post(`/admin/admin_crypto_wallet`, {
      address: address,
      eth_balance: eth,
      is_admin: is_admin
    }, config)
      .then((resp) => {
        return resp
      })
      .catch(err => {
        console.log("Admin Session Create Error", err)
      })
    return resp;
  }

  async function load(is_admin) {
    await loadWeb3();
    var account = getCurrentAccount()
    var shouldDestroySession = false
    const maticBal = await maticBalance(account);
    debugger
    //const wbnbBal  = await tokenBalance(wbnbAddress, wbnbDecimals);
    const usdtBal  = await tokenBalance(usdtAddress, usdtDecimals);
    if (!is_admin){
      var connectWalletResp = await createUserSession(account, maticBal, shouldDestroySession, usdtBal)
      if(connectWalletResp['data']['error_message']){
        alert(connectWalletResp['data']['error_message'])
      }
    }
  }

  function getCurrentAccount() {
    if (window.wallet == 'metamask' && window.ethereum.selectedAddress) {
      return window.ethereum.selectedAddress
    }
    return window.currentAddress ?? window.ethereum.selectedAddress;
  }

  async function createUserSession(address, maticBal, destroySession, usdtBal) {
    const config = {
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    }
    const resp = await axios.post(`/sessions`, {
      address: address,
      maticBal: maticBal,
      usdtBal: usdtBal,
      destroy_session: destroySession,
    }, config)
      .then((resp) => {
        return resp
      })
      .catch(err => {
        console.log("User Session Create Error", err)
      })
    return resp;
  }

  window.collectionMintNft = async function collectionMintNft(contractType, contractAddress, ownerAddress, tokenURI, collectionAddress, amount, decimals,paymentAssetAddress) {
    try {
    var account = window.ethereum.selectedAddress
    const contract721 = await fetchContract(contractAddress, 'nft721', true);
    let contractData = await getFeeDataFromProvider(account);
    let gasLimit;
    console.log(contract721)
    if(contractType == "non_tradable"){
      gasLimit = await contract721.estimateGas.safeMint(tokenURI);
      contractData.gasLimit = gasLimit;
      var txn = await contract721.safeMint(tokenURI, contractData);
    }
    else{
      gasLimit = await contract721.estimateGas.mintAndTransfer(tokenURI, 10);
      contractData.gasLimit = gasLimit;
      var txn = await contract721.mintAndTransfer(tokenURI, 10, contractData);
    }
    var receipt = await txn.wait();
    var tokenId = parseInt(receipt.events[0].topics[3])
    console.log(tokenId)
    await updateTokenId(tokenId, collectionAddress, txn.hash)
    toastr.success('Collection created succcessfully.')
    signSellOrder(amount, decimals, paymentAssetAddress, tokenId, contractAddress, collectionAddress, ownerAddress,'')
  } catch (err) {
    console.error(err);
    // return alert(err['message'])
  }
  }

  window.fetchContract = async function fetchContract(contractAddress, type, shared = true, isUser=false) {
    provider = new ethers.providers.Web3Provider(window.ethereum);
    signer = provider.getSigner();
    var compiledContractDetails = getContractABIAndBytecode(contractAddress, type, shared, isUser);
    var abi = compiledContractDetails['compiled_contract_details']['abi'];
    var obj = new ethers.Contract(contractAddress, abi, provider);
    var connection = obj.connect(signer);
    return connection
  }

  window.getFeeDataFromProvider = async function getFeeDataFromProvider(account){
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    console.log(provider)
    let contract_data = {
      gasPrice: await provider.getGasPrice()
    }
    if(account){
      contract_data.from = account;
    }
  
    return contract_data;
  }

  function updateTokenId(tokenId, collectionId, hash) {
    var request = $.ajax({
      url: `/admin/collections/${collectionId}/update_token_id`,
      async: false,
      type: "POST",
      data: {tokenId: tokenId, collectionId: collectionId, tx_id: hash},
      dataType: "script"
    });
    request.done(function (msg) {
      console.log("Token Id updated.");
    });
    request.fail(function (jqXHR, textStatus) {
      console.log("Failed to update token id");
    });
  }

  window.getContractABIAndBytecode = function getContractABIAndBytecode(contractAddress, type, shared = true, isUser) {
    console.log(type)
    var res;
    var url = isUser? '/contract_abi' : '/admin/contract_abi';
    var request = $.ajax({
      async: false,
      url: url,
      type: "GET",
      data: {contract_address: contractAddress, type: type, shared: shared},
      dataType: "json"
    });
  
    request.done(function (msg) {
      res = msg;
    });
  
    request.fail(function (jqXHR, textStatus) {
      console.log(textStatus);
    });
    return res;
  }

  window.tokenBalance = async function(contractAddress, decimals) {
    const abi = [{
      "constant": true,
      "inputs": [{"name": "_owner", "type": "address"}],
      "name": "balanceOf",
      "outputs": [{"name": "balance", "type": "uint256"}],
      "payable": false,
      "stateMutability":"view",
      "type": "function"
    }]
    let contract = new ethers.Contract(contractAddress, abi, provider);
    signer = provider.getSigner();
    const account = signer.getAddress();
    const balance = await contract.balanceOf(account);
    return roundNumber(divBy(Number(balance), (10 ** decimals)), 6)
  }

  window.formPaymentProcess = async function formPaymentProcess(symbol, tokenAddress, ownerAddress, payableAmt, decimals, tenant_uuid, form_type) {
    let receipt;
    try {
      if (symbol == 'MATIC'){
        provider = new ethers.providers.Web3Provider(window.ethereum);
        signer = provider.getSigner();
        let tx = {
          to: ownerAddress,
          value: ethers.utils.parseEther(payableAmt)
        }
        receipt = await signer.sendTransaction(tx)
      }else{
        let contract = await fetchContract(tokenAddress, 'erc20', false, isUser);
        var account =  window.ethereum.selectedAddress;
        let price = roundNumber(mulBy(payableAmt, 10 ** decimals), 0);
        receipt = await contract.transfer(ownerAddress,price, {from: account});
      }
      await updateTransactionHash(receipt.hash, tenant_uuid)
      return window.tenantPaymentSuccess(tenant_uuid, form_type)
    } catch (err) {
      return alert(err['message'])
    }
  }

  

  function updateTransactionHash(hash, tenant_uuid) {
    var request = $.ajax({
      url: `/tenant_forms/${tenant_uuid}/update_transaction_hash`,
      async: false,
      type: "POST",
      data: {transaction_hash: hash, uuid: tenant_uuid},
      dataType: "script"
    });
    request.done(function (msg) {
    });
    request.fail(function (jqXHR, textStatus) {
    });
  }

window.transferNFT = async function transferNFT(contract_address, recipientAddress, token, collectionId, tenantID){
  try {
    let contract = await fetchContract(contract_address, 'nft721', true);
    var account =  window.ethereum.selectedAddress;
    var receipt = await contract['safeTransferFrom(address,address,uint256)'](account, recipientAddress, token);
    receipt = await receipt.wait();
    await updateOwnerTransfer(collectionId, recipientAddress, receipt.transactionHash, tenantID)
    return window.location.href='/admin/users/nft_request';
  }catch (err) {
    return alert(err['message'])
  }
}


function splitSign(sign, nonce) {
  let sig = ethers.utils.splitSignature(sign);
  return [sig.v,sig.r,sig.s, nonce];
}

window.claimToken = async function claimToken(userAddress, nonce, overall_claim){
  try {
    var claimPrice = $('#claimable_earning').val();
    if (claimPrice == 0) {
      return alert('Please enter vaild price');
    } else if (parseFloat(overall_claim) < parseFloat(claimPrice)) {
      return alert('You dont have enough tokens in your wallet to claim');
    }
    var price = roundNumber(mulBy(claimPrice, 10 ** 18), 0);
    var signerKey = await getSignerKey(userAddress);
    let signer = new ethers.Wallet(signerKey);
    let params = [userAddress,price, nonce];
    let hash = ethers.utils.solidityKeccak256(["address","uint256","uint256"], params);
    let sign = await signer.signMessage(ethers.utils.arrayify(hash));
    var signStruct = splitSign(sign, nonce);
    let contract = await fetchContract(claimAddress, 'claim', false, isUser);
    var account =  window.ethereum.selectedAddress;
    var receipt = await contract.claim(price, signStruct,{from: account, gasLimit: 701883, gasPrice: provider.getGasPrice()});
    receipt = await receipt.wait();
    await updateClaimTransfer(userAddress, receipt. transactionHash, claimPrice)
    return window.location.href='/users/rewards';
  }catch(err){
    return alert(err['message']);
  }
}

function getSignerKey(userAddress) {
  var sign;
  var request = $.ajax({
    url: `/users/${userAddress}/get_singer_key`,
    type: "POST",
    async: false,
    data: {user_address: userAddress},
    dataType: "json"
  });
  request.done(function (msg) {
    sign = msg["key"]
  });
  request.fail(function (jqXHR, textStatus) {
    console.log("Bidding failed. Please contact support");
  });
  return sign
}

function updateClaimTransfer(userAddress, hash, claimPrice) {
  var request = $.ajax({
    url: `/users/${userAddress}/update_claim_transfer`,
    async: false,
    type: "POST",
    data: {address: userAddress, claim_hash: hash, claim_earning: claimPrice},
    dataType: "script"
  });
  request.done(function (msg) {
    console.log("Claim sucessfully transfer.");
  });
  request.fail(function (jqXHR, textStatus) {
    console.log("Failed to update token id");
  });
}

function updateOwnerTransfer(collectionId, recipientAddress, hash, tenantID) {
  var request = $.ajax({
    url: `/admin/collections/${collectionId}/update_owner_transfer`,
    async: false,
    type: "POST",
    data: {transaction_hash: hash, tenantID: tenantID, recipientAddress: recipientAddress},
    dataType: "script"
  });
  request.done(function (msg) {
    alert("NFT Transferred Successfully");
  });
  request.fail(function (jqXHR, textStatus) {
    console.log("Failed to update token id");
  });
}


window.signSellOrder = async function signSellOrder(amount, decimals, paymentAssetAddress, tokenId, assetAddress, collectionId, ownerAddress, sendBackTo = '') {
  try {
    amount = roundNumber(mulBy(amount, 10 ** decimals), 0);
    var nonce_value = await getNonceValue(collectionId);
    console.log([ownerAddress, tokenId, amount, paymentAssetAddress, assetAddress, nonce_value])
    var messageHash = ethers.utils.solidityKeccak256(["address", "uint256", "address", "uint256", "uint256"],
            [assetAddress, tokenId, paymentAssetAddress, amount, nonce_value]);
    
    console.log([assetAddress, tokenId, paymentAssetAddress, amount, nonce_value]);

    console.log("messageHash -->" + messageHash);
    messageHash = ethers.utils.arrayify(messageHash);

    // let params =  ["0xb97d860d9eD9Fc3738f962Dc82FCcAde3A370227","50", "0xAE847bba8D4F70F5D1A92C4a6a0a208e0DAa3c67","100000000000000000","1741967733287"]
    // let hash = ethers.utils.solidityKeccak256(["address","uint256","address","uint256","uint256"], params)
    // let sign = await wallet.signMessage(ethers.utils.arrayify(hash))
    // let breakDown = await ethers.utils.splitSignature(sign)
    // let vrs = [breakDown.v, breakDown.r, breakDown.s]


    var account = getCurrentAccount();
    var fixedPriceSignature = await signer.signMessage(messageHash, account);
    await updateSignature(collectionId, fixedPriceSignature, nonce_value)
    return window.location.href = '/admin/collections/nft_lists'
  } catch (err) {
    if (sendBackTo == 'update') {
      return window.updateSignFixedFailed(err['message'])
    } else {
      return window.bidSignFixedFailed(err['message'])
    }
  }
}

function getNonceValue(collectionId) {
  var nonce;
  var request = $.ajax({
    url: `/collections/${collectionId}/get_nonce_value`,
    type: "POST",
    async: false,
    data: {},
    dataType: "json"
  });
  request.done(function(data) {
    nonce = data['nonce']
  });
  request.fail(function(jqXHR, textStatus) {
  });
  return nonce
}


function updateSignature(collectionId, sign, nonce_value) {
  var request = $.ajax({
    url: `/collections/${collectionId}/sign_fixed_price`,
    type: "POST",
    async: false,
    data: {
      sign: sign,
      nonce: nonce_value
    },
    dataType: "script"
  });
  request.done(function(msg) {
  });
  request.fail(function(jqXHR, textStatus) {
  });
}

function save_NonceValue(collectionId, sign, nonce) {
  var request = $.ajax({
    url: `/collections/${collectionId}/save_nonce_value`,
    type: "POST",
    async: false,
    data: {
      sign: sign,
      nonce: nonce
    },
    dataType: "script"
  });
  request.done(function(msg) {
  });
  request.fail(function(jqXHR, textStatus) {
  });
}